<template>
  <div>
    <template v-if="searchResults.length == 0">
      <button class="add-author-button" @click="showModalAddAuthor">ADD NEW AUTHOR</button>
      <modal-author v-if="showAuthorModal" :modal.sync="showAuthorModal"></modal-author>
      <div class="searching-author">
          <div class="input-label">SEARCH AUTHOR</div>
          <div class="input-box">
              <input
                  class="modal-input"
                  v-model="searchTerm"
                  v-on:input="isTyping = true"
                  placeholder="Start typing to search author..."
              >
          </div>
      </div>
      <md-table>
        <md-table-row>
          <md-table-head>SLUG</md-table-head>
          <md-table-head>DISPLAY NAME</md-table-head>
          <md-table-head>TAGLINE</md-table-head>
        </md-table-row>
          <md-table-row v-for="(item, key) in authorData" :key="key">
            <md-table-cell>{{ item.slug }}</md-table-cell>
            <md-table-cell>{{ item.displayName }}</md-table-cell>
            <md-table-cell>{{ item.authorTagline }}</md-table-cell>
            <md-table-cell><modal-editauthor :passedItem="item"></modal-editauthor></md-table-cell>
            <md-table-cell><modal-delauthor :passedItem="item"></modal-delauthor></md-table-cell>
          </md-table-row>
      </md-table>
      <button @click="moreAuthors" style="margin:5px auto;display: block;width:300px;" v-if="authorData.length == 20">GET MORE AUTHORS</button>
    </template>
    <template v-else>
      <modal-author v-if="showAuthorModal" :modal.sync="showAuthorModal"></modal-author>
      <div class="searching-author">
          <div class="input-label">SEARCH AUTHOR</div>
          <div class="input-box">
              <input
                  class="modal-input"
                  v-model="searchTerm"
                  v-on:input="isTyping = true"
                  placeholder="Start typing to search author..."
              >
          </div>
      </div>
      <md-table>
        <md-table-row>
          <md-table-head>SLUG</md-table-head>
          <md-table-head>DISPLAY NAME</md-table-head>
          <md-table-head>TAGLINE</md-table-head>
        </md-table-row>
          <md-table-row v-for="(item, key) in searchResults" :key="key">
            <md-table-cell>{{ item.slug }}</md-table-cell>
            <md-table-cell>{{ item.displayName }}</md-table-cell>
            <md-table-cell>{{ item.authorTagline }}</md-table-cell>
            <md-table-cell><modal-editauthor :passedItem="item"></modal-editauthor></md-table-cell>
            <md-table-cell><modal-delauthor :passedItem="item"></modal-delauthor></md-table-cell>
          </md-table-row>
      </md-table>
    </template>
  </div>
</template>

<script>
import Vue from "vue";
import firebase from "firebase";
import VueFirestore from "vue-firestore";
require("firebase/firestore");
Vue.use(VueFirestore);
var firestore;
import ModalAuthor from "../ModalAuthor.vue";
import ModalDelauthor from "../ModalDelauthor.vue";
import ModalEditauthor from "../ModalEditauthor.vue";
export default {
  components: {ModalAuthor, ModalDelauthor, ModalEditauthor},
  data: function() {
    firestore = firebase.firestore();
    return {
      showAuthorModal:false,
      startAfter: null,
      searchTerm:"",
      searchResults:[],
      isTyping: false,
    };
  },
  watch: {
      startAfter: function(val, oldval) {
          if(val) {
              this.updateFilter();
          }
      },
      searchTerm: _.debounce(function() {
        this.isTyping = false;
      }, 1000),
      isTyping: function(value) {
        if (!value) {
          this.searchForTerm(this.searchTerm);
        }
      }
  },
  firestore() {
    return {
      authorData: firestore.collection("authors").limit(20).orderBy("slug")
    };
  },
  methods: {
    showModalAddAuthor: function() {
      this.showAuthorModal = true;
    },
    moreAuthors: function() {
        this.startAfter = this.authorData[this.authorData.length-1].slug;
        window.scrollTo(0,0);
    },
    updateFilter: function() {
        Vue.nextTick(() => {
          var ref = firestore.collection("authors");
          ref = ref.limit(20).orderBy("slug");
          if(this.startAfter) ref = ref.startAfter(this.startAfter);
          this.$binding("authorData", ref);
        });
    },
    searchForTerm: function(){
      this.searchResults = [];
      this.searchTerm = this.searchTerm.toLowerCase().replace(/\s/g, '-').replace(/[^a-z0-9\-]+/gi, '');
      var strlength = this.searchTerm.length;
      var strFrontCode = this.searchTerm.slice(0, strlength-1);
      var strEndCode = this.searchTerm.slice(strlength-1, this.searchTerm.length);
      var endcode= strFrontCode + String.fromCharCode(strEndCode.charCodeAt(0) + 1);
      var startcode = this.searchTerm;
      firestore
        .collection("authors")
        .where('slug', '>=', startcode)
        .where('slug', '<', endcode)
        .limit(20)
        .get()
        .then(snapshot => {
          if (snapshot.empty) {
            console.log('No matching documents.');
            return;
          }
          snapshot.forEach(doc => {
            this.searchResults.push({
                aboutAuthor: doc.data().aboutAuthor,
                authorTagline: doc.data().authorTagline,
                displayName: doc.data().displayName,
                slug: doc.data().slug,
                authorSeoDesc: doc.data().authorSeoDesc,
                authorSeoTitle: doc.data().authorSeoTitle,
                customAvatar: doc.data().customAvatar
            });
          });
        })
        .catch(err => {
          console.log('Error getting search results for author', err);
        });
    }
  }
};
</script>
<style scoped>
.add-author-button {
  background-color: #ff5252;
}
.searching-author{
  width:300px;
  float:right;
}
</style>



// WEBPACK FOOTER //
// authors.vue?f8b662a2